import { ProductVariant } from "../types/product"

export const isColorVariant = (variant: ProductVariant) => !!variant.info.color

export const isQuantityVariant = (variant: ProductVariant) =>
  !isColorVariant(variant) && variant.info.quantity

export const hasCrossedPrice = (variant: ProductVariant) =>
  variant.inventory?.compareAtPrice &&
  variant.inventory.compareAtPrice > variant.inventory.price
